
import React from 'react';

// Styles
import StyleWrapper from './Wrapper';

export default class OverlayLoading extends React.Component {
    constructor (props) {
        super(props);

        this.renderType = props && props.renderAs || 'page';
        this.className = props && props.className || '';
    }

    render() {
        return (
            <StyleWrapper className={`${this.renderType} ${this.className}`}>
                <div className="loader-container">
                    <div className="ripple-effect">
                        <div></div>
                        <div></div>
                    </div>|
                </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/components/OverlayLoading/index.js